import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import {
  getById,
  search,
  create,
  update,
  remove,
  getListPhaseByProject
} from './phases-api';

import * as PhaseActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: PhaseActionType.GET_PHASE_BY_ID_SUCCESS, data: result.data });
    if (action.callback) {action.callback();}

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }

}

export function* createAsync(action) {

  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: PhaseActionType.SEARCH_PHASE_ASYNC, params: action.params.search })
    ];
  } else {
    yield put({
      type: PhaseActionType.CREATE_UPDATE_PHASE_ERROR, data: {
        error: result.data,
        params: action.params.data,
        isEdit: action.params.isEdit
      }
    });
  }
}

export function* updateAsync(action) {

  const result = yield call(update, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: PhaseActionType.SEARCH_PHASE_ASYNC, params: action.params.search }),
      put({ type: PhaseActionType.UPDATE_PHASE_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: PhaseActionType.CREATE_UPDATE_PHASE_ERROR, data: {
        error: result.data,
        params: action.params.data,
        isEdit: action.params.isEdit
      }
    });
  }
}

export function* searchAsync(action) {

  const result = yield call(search, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: PhaseActionType.SEARCH_PHASE_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }

}

export function* deleteAsync(action) {

  const result = yield call(remove, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: PhaseActionType.SEARCH_PHASE_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }

}

export function* getListPhaseByProjectAsync(action) {
  const result = yield call(getListPhaseByProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: PhaseActionType.GET_LIST_PHASE_BY_PROJECT_SUCCESS, data: result.data })
    ];
    if (action.callback) {action.callback();}
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }

}

export default function* WatchPhases() {
  yield all([
    takeLatest(PhaseActionType.SEARCH_PHASE_ASYNC, searchAsync),
    takeLatest(PhaseActionType.GET_PHASE_BY_ID_ASYNC, getByIdAsync),
    takeLatest(PhaseActionType.UPDATE_PHASE_ASYNC, updateAsync),
    takeLatest(PhaseActionType.CREATE_PHASE_ASYNC, createAsync),
    takeLatest(PhaseActionType.DELETE_PHASE_ASYNC, deleteAsync),
    takeLatest(PhaseActionType.GET_LIST_PHASE_BY_PROJECT_ASYNC, getListPhaseByProjectAsync)
  ]);
}




// WEBPACK FOOTER //
// ./src/Projects/phase-saga.js